import { NgModule } from '@angular/core';
import { DirectDebitComponent } from './direct-debit.component';
import { CheckForCardComponent } from './components/check-for-card/check-for-card.component';
import { SuccessComponent } from './components/success/success.component';
import { ErrorComponent } from './components/error/error.component';
import { CalculatorResultComponent } from './components/calculator-result/calculator-result.component';

import { DirectDebitGuard } from './guard/direct-debit.guard';
import { RouterModule, Route } from '@angular/router';
import { MainLayoutComponent } from '../main-layout/main-layout.component';
import { Roles } from '../../shared/cardholders-core/services/auth.service';
import { DestinationCardsComponent } from './components/destination-cards/destination-cards.component';

export const routes: Route[] = [
    {
        path: '',
        component: MainLayoutComponent,
        data: {
            authConfig: {
                roles: [Roles.REG, Roles.GALI, Roles.IVR, Roles.SENSITIVEIVR, Roles.WS, Roles.ADMIN, Roles.SL]
            }
        },
        children: [
            {
                path: '',
                component: DirectDebitComponent,
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'check-for-card'
                    },
                    {
                        path: 'check-for-card',
                        component: CheckForCardComponent,
                        data: {
                            minimalHedaer: true
                        }
                    },
                    {
                        path: 'success',
                        component: SuccessComponent,
                        canActivate: [DirectDebitGuard],
                        data: {
                            minimalHedaer: true
                        }
                    },
                    {
                        path: 'error',
                        component: ErrorComponent,
                        canActivate: [DirectDebitGuard],
                        data: {
                            minimalHedaer: true
                        }
                    },
                    {
                        path: 'calculator-result',
                        component: CalculatorResultComponent,
                        canActivate: [DirectDebitGuard],
                        data: {
                            minimalHedaer: true
                        }
                    },
                    {
                        path: 'main-debit-list',
                        data: {
                            minimalHedaer: false
                        },
                        loadChildren: () =>
                            import('./components/main-debit-list/main-debit-list.module').then(
                                (m) => m.MainDebitListModule
                            )
                    },

                    {
                        path: 'destination-card',
                        canActivate: [DirectDebitGuard],
                        component: DestinationCardsComponent,
                        data: {
                            minimalHedaer: true
                        }
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DirectDebitRoutingModule {}
